import dayjs from "dayjs";
import {CurrentUtils} from "xmgoing-server";
import {CommonEnum} from "@/main-page/utils/CommonEnum";
import {GoingNewUtils} from "xmgoing-utils";
import {StorageUtils} from 'xmgoing-utils';
import {
  averageFunDeal,
  concateNameFunDeal,
  exactAbsDeal,
  exactADDDeal,
  exactAndDeal,
  exactCeilingDeal,
  exactDATEDeal,
  exactDATEDELTADeal,
  exactDateRangeDaysDeal,
  exactDAYDeal,
  exactDAYSDeal,
  exactDEPTNAMEDeal, exactDivisionDeal,
  exactEqDeal,
  exactFixedDeal,
  exactFloorDeal,
  exactFunDeal,
  exactGeDeal,
  exactGETUSERNAMEDeal,
  exactGtDeal,
  exactHOURDeal,
  exactIfDeal,
  exactIntDeal,
  exactLargeDeal,
  exactLeDeal,
  exactLeftDeal,
  exactLenDeal,
  exactLogDeal,
  exactLOGINUSERWORKNODeal,
  exactLowerDeal,
  exactLtDeal,
  exactMaxDeal,
  exactMidDeal,
  exactMinDeal,
  exactMINUTEDeal,
  exactModDeal,
  exactMONTHDeal, exactMonthEndDeal,
  exactNeDeal,
  exactNotDeal,
  exactNumberCompareDeal,
  exactOrDeal,
  exactPinyInHeadCharDeal,
  exactPowerDeal,
  exactProductDeal,
  exactReplaceDeal,
  exactReptDeal,
  exactRightDeal,
  exactRmbFormatDeal,
  exactRoundDeal,
  exactSearchDeal,
  exactSECONDDeal,
  exactSplitDeal,
  exactSqrtDeal, exactSUBDeal,
  exactSumproductDeal,
  exactTextDeal,
  exactTimeCompareDeal,
  exactTrimDeal,
  exactUpperDeal,
  exactValueDeal, exactWEEKNUMDeal,
  exactXorDeal, exactYEARBEGINDeal, exactYEARCOUNTDeal,
  exactYEARDeal, exactYEARENDDeal,
  isEmptyFunDeal,
  sumFunDeal,
  timestampFunDeal
} from "@/main-page/utils/funDealUtils";


export function initDefValuesByFun({
                                     propDef,
                                     props,
                                     modelObj,
                                     record = {},
                                     componentKey,
                                     model
                                   }, rootNode = true) {
  let backValue: any = '';
  propDef.forEach((configItem) => {
    let setValue = true;
    const {type, title, args} = configItem;
    if (type === "fun") {
      switch (title) {
        case "UUID":
          backValue = GoingNewUtils.getUUChar(25);
          break
        case "ARRAYGET":
          backValue = averageFunDeal({props, modelObj, model, args, componentKey});
          break
        case "TODAY":
          backValue = dayjs().format(unref(props).format || "YYYY-MM-DD");
          break
        //AVERAGE函数可以获取一组数值的算术平均值
        case "AVERAGE":
          backValue = averageFunDeal({props, modelObj, model, args, componentKey});
          break
        //CONCATENATE函数可以将多个文本合并成一个文本
        case "CONCATENATE":
          backValue = concateNameFunDeal({props, modelObj, model, args, componentKey});
          break
        //ISEMPTY函数可以用来判断值是否为空文本、空对象或者空数组
        case "ISEMPTY":
          backValue = isEmptyFunDeal({props, modelObj, model, args, componentKey});
          break
        //SUM函数可以获取一组数值的总和
        case "SUM":
          backValue = sumFunDeal({props, modelObj, model, args, componentKey});
          break
        //函数可以将日期对象转换成时间戳。
        case "TIMESTAMP":
          backValue = timestampFunDeal({props, modelObj, model, args, componentKey});
          break
        case "EXACT":
          backValue = exactFunDeal({props, modelObj, model, args, componentKey});
          break
        case "LEFT":
          backValue = exactLeftDeal({props, modelObj, model, args, componentKey});
          break
        case "LEN":
          backValue = exactLenDeal({props, modelObj, model, args, componentKey});
          break
        case "LOWER":
          backValue = exactLowerDeal({props, modelObj, model, args, componentKey});
          break
        case "MID":
          backValue = exactMidDeal({props, modelObj, model, args, componentKey});
          break
        case "PINYINHEADCHAR":
          backValue = exactPinyInHeadCharDeal({props, modelObj, model, args, componentKey});
          break
        case "REPLACE":
          backValue = exactReplaceDeal({props, modelObj, model, args, componentKey});
          break
        case "REPT":
          backValue = exactReptDeal({props, modelObj, model, args, componentKey});
          break
        case "RIGHT":
          backValue = exactRightDeal({props, modelObj, model, args, componentKey});
          break
        case "RMBFORMAT":
          backValue = exactRmbFormatDeal({props, modelObj, model, args, componentKey});
          break
        case "SEARCH":
          backValue = exactSearchDeal({props, modelObj, model, args, componentKey});
          break
        case "SPLIT":
          backValue = exactSplitDeal({props, modelObj, model, args, componentKey});
          break
        case "TEXT":
          backValue = exactTextDeal({props, modelObj, model, args, componentKey});
          break
        case "TRIM":
          backValue = exactTrimDeal({props, modelObj, model, args, componentKey});
          break
        case "UPPER":
          backValue = exactUpperDeal({props, modelObj, model, args, componentKey});
          break
        case "VALUE":
          backValue = exactValueDeal({props, modelObj, model, args, componentKey});
          break
        case "AND":
          backValue = exactAndDeal({props, modelObj, model, args, componentKey});
          break
        case "EQ":
          backValue = exactEqDeal({props, modelObj, model, args, componentKey});
          break
        case "FALSE":
          backValue = false;
          break
        case "GE":
          //函数用于比较两个数的大小，value1大于等于value2返回true
          backValue = exactGeDeal({props, modelObj, model, args, componentKey});
          break
        case "GT":
          //函数用于比较两个数的大小，value1大于value2返回true
          backValue = exactGtDeal({props, modelObj, model, args, componentKey});
          break
        case "IF":
          //函数判断一个条件能否满足；如果满足返回一个值，如果不满足则返回另外一个值
          backValue = exactIfDeal({props, modelObj, model, args, componentKey});
          break
        case "LE":
          //函数用于比较两个数的大小，value1小于等于value2返回true
          backValue = exactLeDeal({props, modelObj, model, args, componentKey});
          break
        case "LT":
          backValue = exactLtDeal({props, modelObj, model, args, componentKey});
          break
        case "NE":
          backValue = exactNeDeal({props, modelObj, model, args, componentKey});
          break
        case "NOT":
          backValue = exactNotDeal({props, modelObj, model, args, componentKey});
          break
        case "NUMBERCOMPARE":
          //函数用于比较两个数字的大小
          backValue = exactNumberCompareDeal({props, modelObj, model, args, componentKey});
          break
        case "OR":
          backValue = exactOrDeal({props, modelObj, model, args, componentKey});
          break
        case "TIMECOMPARE":
          backValue = exactTimeCompareDeal({props, modelObj, model, args, componentKey});
          break
        case "TRUE":
          backValue = true;
          break
        case "XOR":
          backValue = exactXorDeal({props, modelObj, model, args, componentKey});
          break
        case "ABS":
          //返回一个数的绝对值:
          backValue = exactAbsDeal({props, modelObj, model, args, componentKey});
          break
        case "SUB":
          //函数用于返回组件值相减。
          backValue = exactSUBDeal({props, modelObj, model, args, componentKey});
          break
        case "ADD":
          //函数用于返回组件值相加总和。
          backValue = exactADDDeal({props, modelObj, model, args, componentKey});
          break
        case "CEILING":
          backValue = exactCeilingDeal({props, modelObj, model, args, componentKey});
          break
        case "FIXED":
          backValue = exactFixedDeal({props, modelObj, model, args, componentKey});
          break
        case "FLOOR":
          backValue = exactFloorDeal({props, modelObj, model, args, componentKey});
          break
        case "INT":
          backValue = exactIntDeal({props, modelObj, model, args, componentKey});
          break
        case "LARGE":
          backValue = exactLargeDeal({props, modelObj, model, args, componentKey});
          break
        case "LOG":
          backValue = exactLogDeal({props, modelObj, model, args, componentKey});
          break
        case "MAX":
          backValue = exactMaxDeal({props, modelObj, model, args, componentKey});
          break
        case "MIN":
          backValue = exactMinDeal({props, modelObj, model, args, componentKey});
          break
        case "MOD":
          backValue = exactModDeal({props, modelObj, model, args, componentKey});
          break
        case "POWER":
          backValue = exactPowerDeal({props, modelObj, model, args, componentKey});
          break
        case "PRODUCT":
          backValue = exactProductDeal({props, modelObj, model, args, componentKey});
          break
        case "DIVISION":
          backValue = exactDivisionDeal({props, modelObj, model, args, componentKey});
          break
        case "ROUND":
          backValue = exactRoundDeal({props, modelObj, model, args, componentKey});
          break
        case "SQRT":
          backValue = exactSqrtDeal({props, modelObj, model, args, componentKey});
          break
        case "SUMPRODUCT":
          backValue = exactSumproductDeal({props, modelObj, model, args, componentKey});
          break
        case "GETUSERNAME":
          //函数用于获取当前登录人名称
          backValue = exactGETUSERNAMEDeal({props, modelObj, model, args, componentKey});
          break
        case "LOGINUSERWORKNO":
          //函数用于获取当前登录人工号
          backValue = exactLOGINUSERWORKNODeal({props, modelObj, model, args, componentKey});
          break
        case "DEPTNAME":
          //函数用于获取指定人所在部门名称
          backValue = exactDEPTNAMEDeal({props, modelObj, model, args, componentKey});
          break

        case "DATE":
          //函数用于获取指定人所在部门名称
          backValue = exactDATEDeal({props, modelObj, model, args, componentKey});
          break

        case "DATEDELTA":
          //函数可以将指定日期加/减指定天数
          backValue = exactDATEDELTADeal({props, modelObj, model, args, componentKey});
          break

        case "monthEnd":
          //函数可以将指定日期加/减指定天数
          backValue = exactMonthEndDeal({props, modelObj, model, args, componentKey});
          break

        case "WEEKNUM":
          //函数可以将指定日期加/减指定天数
          backValue = exactWEEKNUMDeal({props, modelObj, model, args, componentKey});
          break

        case "YEAR":
          //函数用于获取指定人所在部门名称
          backValue = exactYEARDeal({props, modelObj, model, args, componentKey});
          break
        case "YEAREND":
          //函数用于获取指定人所在部门名称
          backValue = exactYEARENDDeal({props, modelObj, model, args, componentKey});
          break
        case "YEARCOUNT":
          //函数用于获取指定人所在部门名称
          backValue = exactYEARCOUNTDeal({props, modelObj, model, args, componentKey});
          break
        case "YEARBEGIN":
          //函数用于获取指定人所在部门名称
          backValue = exactYEARBEGINDeal({props, modelObj, model, args, componentKey});
          break
        case "MONTH":
          //函数用于获取指定人所在部门名称
          backValue = exactMONTHDeal({props, modelObj, model, args, componentKey});
          break
        case "DAY":
          //函数用于获取指定人所在部门名称
          backValue = exactDAYDeal({props, modelObj, model, args, componentKey});
          break
        case "DAYS":
          //函数用于获取指定人所在部门名称
          backValue = exactDAYSDeal({props, modelObj, model, args, componentKey});
        case "DateRangeDays":
          //函数用于获取指定人所在部门名称
          backValue = exactDateRangeDaysDeal({props, modelObj, model, args, componentKey});
          break
        case "HOUR":
          //函数用于获取指定人所在部门名称
          backValue = exactHOURDeal({props, modelObj, model, args, componentKey});
          break
        case "MINUTE":
          //函数用于获取指定人所在部门名称
          backValue = exactMINUTEDeal({props, modelObj, model, args, componentKey});
          break
        case "LOGINUSER":
          setValue = false;
          CurrentUtils._loadUser(false, (userJson) => {
            //如果是人员选择
            if (componentKey === CommonEnum.CTL_USER_SELECT) {
              unref(modelObj)[unref(model).key] = [userJson["id"]];
            } else {
              unref(modelObj)[unref(model).key] = userJson["name"];
            }
          })
          break
        default:
          break;
      }
      if (rootNode && setValue) {
        if (backValue !== null && unref(model)) {
          if (unref(record)) {
            unref(record)[unref(model).key] = backValue;
          } else {
            unref(modelObj)[unref(model).key] = backValue;
          }
        }
      }
    }
  })
  return backValue;
}

export type ResolveShortcutOptions = {
  format?: string;
  defFormat?: string;
};

/** 从 session 同步读取当前用户（与 initDefValues 异步 _loadUser 结果对齐） */
function getCachedUserJson(): Record<string, any> | null {
  try {
    const curJsonStr = StorageUtils.getSessionItem('curUserJson');
    if (curJsonStr) {
      return JSON.parse(curJsonStr);
    }
  } catch {
    // ignore
  }
  return null;
}

function getCachedUserId(): string | undefined {
  const userJson = getCachedUserJson();
  if (userJson?.id != null && userJson.id !== '') {
    return String(userJson.id);
  }
  const sessionUserId = StorageUtils.getSessionItem('userId') || StorageUtils.getSessionItem('curUserId');
  return sessionUserId || undefined;
}

function formatDayRange(subCount: number, join = ';') {
  const curMStr = dayjs().format('YYYY-MM-DD');
  return [
    dayjs(curMStr).subtract(subCount, 'day').format('YYYY-MM-DD'),
    curMStr,
  ].join(join);
}

function formatMonthRange(subCount: number) {
  const curMStr = dayjs().startOf('year').format('YYYY') + '-' + dayjs().startOf('month').format('MM');
  return [
    dayjs(curMStr, 'YYYY-MM').subtract(subCount, 'month').format('YYYY-MM'),
    curMStr,
  ];
}

/**
 * 同步解析「快捷配置」默认值
 * 供子表数据层在未渲染分页行上补全 currentDateTime / currentUserId 等
 */
export function resolveShortcutDefaultValue(
  propDef: string,
  options: ResolveShortcutOptions = {},
): any {
  if (propDef == null || propDef === '') {
    return undefined;
  }

  const format = options.format || options.defFormat || 'YYYY-MM-DD';

  if (CommonEnum.CURRENT_TIME === propDef) {
    return dayjs().format(format || 'HH:mm:ss');
  }
  if (propDef === 'currentTimeRang') {
    const fmt = format || 'HH:mm';
    return `${dayjs().startOf('day').format(fmt)};${dayjs().endOf('day').format(fmt)}`;
  }
  if (CommonEnum.WEILAI_one === propDef) {
    return dayjs().add(1, 'day').format('YYYY-MM-DD');
  }
  if (CommonEnum.WEILAI_two === propDef) {
    return dayjs().add(2, 'day').format('YYYY-MM-DD');
  }
  if (CommonEnum.WEILAI_three === propDef) {
    return dayjs().add(3, 'day').format('YYYY-MM-DD');
  }
  if (CommonEnum.WEILAI_seven === propDef) {
    return dayjs().add(7, 'day').format('YYYY-MM-DD');
  }
  if (CommonEnum.THIRTH_seven === propDef) {
    return dayjs().add(30, 'day').format('YYYY-MM-DD');
  }
  if (CommonEnum.CURRENT_YEAR === propDef) {
    return dayjs().format('YYYY');
  }
  if (CommonEnum.PRE_YEAR === propDef) {
    return parseFloat(dayjs().endOf('year').format('YYYY') + '') - 1;
  }
  if (CommonEnum.CURRENT_MONTH === propDef) {
    return dayjs().endOf('month').format('YYYY-MM');
  }
  if (CommonEnum.PRE_MONTH === propDef) {
    return dayjs().add(-1, 'month').endOf('month').format('YYYY-MM');
  }
  if (propDef === 'curMonthStart') {
    return dayjs().startOf('year').format('YYYY-MM');
  }
  if (propDef === 'curMonthEnd') {
    return dayjs().endOf('year').format('YYYY-MM');
  }
  if (CommonEnum.RECENTLY_D_3 === propDef) {
    return formatDayRange(3);
  }
  if (CommonEnum.RECENTLY_D_4 === propDef) {
    return formatDayRange(3);
  }
  if (CommonEnum.RECENTLY_D_7 === propDef) {
    return formatDayRange(7);
  }
  if (CommonEnum.RECENTLY_D_15 === propDef) {
    return formatDayRange(15);
  }
  if (CommonEnum.RECENTLY_D_30 === propDef) {
    return formatDayRange(30);
  }
  if (propDef === 'recentlyDay1') {
    return formatDayRange(0);
  }
  if (CommonEnum.RECENTLY_M_3 === propDef) {
    return formatMonthRange(3);
  }
  if (CommonEnum.RECENTLY_M_6 === propDef) {
    return formatMonthRange(6);
  }
  if (CommonEnum.RECENTLY_M_12 === propDef) {
    return formatMonthRange(12);
  }
  if (CommonEnum.RECENTLY_3 === propDef) {
    return [
      (parseFloat(dayjs().startOf('year').format('YYYY')) - 3) + '',
      dayjs().startOf('year').format('YYYY'),
    ];
  }
  if (CommonEnum.RECENTLY_5 === propDef) {
    return [
      (parseFloat(dayjs().startOf('year').format('YYYY')) - 5) + '',
      dayjs().startOf('year').format('YYYY'),
    ];
  }
  if (CommonEnum.RECENTLY_10 === propDef) {
    return [
      (parseFloat(dayjs().startOf('year').format('YYYY')) - 10) + '',
      dayjs().startOf('year').format('YYYY'),
    ];
  }
  if (CommonEnum.CURRENT_DATE === propDef) {
    return dayjs().format(format);
  }
  if (CommonEnum.CURRENT_DATE_TIME === propDef) {
    return dayjs().format('YYYY-MM-DD HH:mm');
  }
  if (CommonEnum.CURRENT_START_TIME === propDef) {
    return dayjs().startOf('day').format('YYYY-MM-DD HH:mm');
  }
  if (CommonEnum.CURRENT_END_TIME === propDef) {
    return dayjs().endOf('day').format('YYYY-MM-DD HH:mm');
  }
  if (CommonEnum.UUID === propDef) {
    return GoingNewUtils.getUUChar(22);
  }

  const userJson = getCachedUserJson();
  if (CommonEnum.CURRENT_USER === propDef) {
    return userJson?.name;
  }
  if (CommonEnum.CURRENT_USER_ID === propDef) {
    return userJson?.id != null ? String(userJson.id) : getCachedUserId();
  }
  if (CommonEnum.CURRENT_USER_NO === propDef) {
    return userJson?.workNo ?? userJson?.userNo;
  }
  if (CommonEnum.TENANT_NAME_ID === propDef) {
    return userJson?.tenantId;
  }
  if (CommonEnum.TENANT_NAME === propDef) {
    return userJson?.tenantName;
  }
  if (CommonEnum.CURRENT_ORG === propDef) {
    return userJson?.deptName || '无部门';
  }
  if (CommonEnum.CURRENT_ORG_ID === propDef) {
    return userJson?.deptId || '无部门';
  }

  return undefined;
}

function initMonth({propDef, props, defFormat, modelObj, model}, subCount) {
  const curMStr = dayjs().startOf('year').format('YYYY') + "-" + dayjs().startOf('month').format('MM');
  if (unref(modelObj) && unref(model)) {
    unref(modelObj)[unref(model).key] = [
      dayjs(dayjs(curMStr, "YYYY-MM").subtract(subCount, 'month')).format("YYYY-MM"),
      curMStr,
    ];
  }
}

/**
 * 初始化本周的值
 * @param propDef
 * @param props
 * @param defFormat
 * @param modelObj
 * @param model
 * @param subCount
 */
function initDay({modelObj, pItemType, model}, subCount) {
  const curMStr = dayjs().startOf('year').format('YYYY') + "-" + dayjs().startOf('month').format('MM') + "-" + dayjs().startOf('day').format('DD');
  if (unref(modelObj) && unref(model)) {
    if (pItemType === 'xmQueryForm') {
      const dateAry = [
        dayjs(dayjs(curMStr, "YYYY-MM-DD").subtract(subCount, 'day')).format("YYYY-MM-DD"),
        curMStr,
      ];
      //ge大于等于
      unref(modelObj)[unref(model).key + '_ge'] = dateAry[0];
      //le小于等于
      unref(modelObj)[unref(model).key + '_le'] = dateAry[1];
    } else {
      unref(modelObj)[unref(model).key] = [
        dayjs(dayjs(curMStr, "YYYY-MM-DD").subtract(subCount, 'day')).format("YYYY-MM-DD"),
        curMStr,
      ].join(";");
    }
  }
}

/**
 * 初始化默认值
 * @param propDef
 * @param props
 * @param defFormat
 * @param modelObj
 */
export const initDefValues = function ({
                                         state,
                                         valueType,
                                         pItemType,
                                         propDef,
                                         model,
                                         props,
                                         defFormat,
                                         modelObj,
                                         componentKey
                                       }, backFun?: any) {
  if (propDef == null || propDef == undefined) {
    return;
  }
  if ("session缓存" === valueType) {
    unref(modelObj)[unref(model).key] = StorageUtils.getSessionItem(propDef);
    return
  }
  if ("全局状态变量" === valueType) {
    if (unref(props)['subDefaultValue']) {
      if (unref(state)[unref(props)['defaultValue']]) {
        unref(modelObj)[unref(model).key] = unref(state)[unref(props)['defaultValue']][unref(props)['subDefaultValue']];
      } else {
        unref(modelObj)[unref(model).key] = '';
      }
    } else {
      unref(modelObj)[unref(model).key] = unref(state)[unref(props)['defaultValue']];
    }
    return
  }
  if (CommonEnum.CURRENT_TIME === propDef) {
    unref(modelObj)[unref(model).key] = dayjs(`${new Date()}`).format(unref(props).format || 'HH:mm:ss');
    return
  }
  if ("currentTimeRang" === propDef) {
    unref(modelObj)[unref(model).key] = dayjs().startOf('day').format(unref(props).format || 'HH:mm') + ";" + dayjs().endOf('day').format(unref(props).format || 'HH:mm')
    return
  }

  //未来1天
  if (CommonEnum.WEILAI_one === propDef) {
    unref(modelObj)[unref(model).key] = dayjs(dayjs().add(1, "day")).format("YYYY-MM-DD");
    return
  }
  //未来2天
  if (CommonEnum.WEILAI_two === propDef) {
    unref(modelObj)[unref(model).key] = dayjs(dayjs().add(2, "day")).format("YYYY-MM-DD");
    return
  }
  //未来3天
  if (CommonEnum.WEILAI_three === propDef) {
    unref(modelObj)[unref(model).key] = dayjs(dayjs().add(3, "day")).format("YYYY-MM-DD");
    return
  }
  //未来7天
  if (CommonEnum.WEILAI_seven === propDef) {
    unref(modelObj)[unref(model).key] = dayjs(dayjs().add(7, "day")).format("YYYY-MM-DD");
    return
  }
  //未来30
  if (CommonEnum.THIRTH_seven === propDef) {
    unref(modelObj)[unref(model).key] = dayjs(dayjs().add(30, "day")).format("YYYY-MM-DD");
    return
  }
  //当前年
  if (CommonEnum.CURRENT_YEAR === propDef) {
    unref(modelObj)[unref(model).key] = dayjs(`${new Date()}`).format('YYYY');
    return
  }
  //前一年
  if (CommonEnum.PRE_YEAR === propDef) {
    unref(modelObj)[unref(model).key] = parseFloat(dayjs().endOf('year').format('YYYY') + '') - 1;
    return
  }
  //
  if (CommonEnum.CURRENT_MONTH === propDef) {
    unref(modelObj)[unref(model).key] = dayjs().endOf('month').format('YYYY-MM');
    return
  }
  if (CommonEnum.PRE_MONTH === propDef) {
    unref(modelObj)[unref(model).key] = dayjs().add(-1, 'month').endOf('month').format('YYYY-MM');
    return
  }
  if ("curMonthStart" === propDef) {
    unref(modelObj)[unref(model).key] = dayjs().startOf('year').format('YYYY-MM');
    return
  }

  if ("curMonthEnd" === propDef) {
    unref(modelObj)[unref(model).key] = dayjs().endOf('year').format('YYYY-MM');
    return
  }

  if (CommonEnum.RECENTLY_D_3 === propDef) {
    initDay({modelObj, pItemType, model}, 3);
    return
  }
  if (CommonEnum.RECENTLY_D_4 === propDef) {
    initDay({modelObj, pItemType, model}, 3);
    return
  }
  if (CommonEnum.RECENTLY_D_7 === propDef) {
    initDay({modelObj, pItemType, model}, 7);
    return
  }
  if (CommonEnum.RECENTLY_D_15 === propDef) {
    initDay({modelObj, pItemType, model}, 15);
    return
  }
  if (CommonEnum.RECENTLY_D_30 === propDef) {
    initDay({modelObj, pItemType, model}, 30);
    return
  }

  if (CommonEnum.RECENTLY_M_3 === propDef) {
    initMonth({propDef, props, defFormat, modelObj, model}, 3);
    return
  }
  if (CommonEnum.RECENTLY_M_6 === propDef) {
    initMonth({propDef, props, defFormat, modelObj, model}, 6);
    return
  }
  if (CommonEnum.RECENTLY_M_12 === propDef) {
    initMonth({propDef, props, defFormat, modelObj, model}, 12);
    return
  }

  if ('recentlyDay1' === propDef) {
    initDay({modelObj, pItemType, model}, 0);
    return
  }

  if (CommonEnum.RECENTLY_3 === propDef) {
    unref(modelObj)[unref(model).key] = [
      (parseFloat(dayjs().startOf('year').format('YYYY')) - 3) + '',
      dayjs().startOf('year').format('YYYY'),
    ];
    return
  }
  if (CommonEnum.RECENTLY_5 === propDef) {
    unref(modelObj)[unref(model).key] = [
      (parseFloat(dayjs().startOf('year').format('YYYY')) - 5) + '',
      dayjs().startOf('year').format('YYYY'),
    ];
    return
  }
  if (CommonEnum.RECENTLY_10 === propDef) {
    unref(modelObj)[unref(model).key] = [
      (parseFloat(dayjs().startOf('year').format('YYYY')) - 10) + '',
      dayjs().startOf('year').format('YYYY'),
    ];
    return
  }
  //如果是当前日期
  if (CommonEnum.CURRENT_DATE === propDef) {
    const dayStr = dayjs().format(unref(props).format || defFormat);
    unref(modelObj)[unref(model).key] = dayStr;
    return
  }
  //如果是当前日期时间
  if (CommonEnum.CURRENT_DATE_TIME === propDef) {
    const dayStr = dayjs().format('YYYY-MM-DD HH:mm');
    unref(modelObj)[unref(model).key] = dayStr;
    return
  }
  //如果是当前日期时间
  if (CommonEnum.CURRENT_START_TIME === propDef) {
    const dayStr = dayjs().startOf('day').format('YYYY-MM-DD HH:mm');
    unref(modelObj)[unref(model).key] = dayStr;
    return
  }
  //如果是当前日期时间
  if (CommonEnum.CURRENT_END_TIME === propDef) {
    const dayStr = dayjs().endOf('day').format('YYYY-MM-DD HH:mm');
    unref(modelObj)[unref(model).key] = dayStr;
    return
  }
  //随机字符串id
  if (CommonEnum.UUID === propDef) {
    unref(modelObj)[unref(model).key] = GoingNewUtils.getUUChar(22);
    return
  }
  //当前用户
  if (CommonEnum.CURRENT_USER === propDef || CommonEnum.CURRENT_USER_ID === propDef || CommonEnum.TENANT_NAME_ID === propDef || CommonEnum.TENANT_NAME === propDef) {
    CurrentUtils._loadUser(false, (userJson) => {
      if (CommonEnum.CURRENT_USER === propDef) {
        //如果是人员选择
        unref(modelObj)[unref(model).key] = userJson["name"];
        backFun && backFun(userJson["name"]);
        return
      }
      if (CommonEnum.CURRENT_USER_ID === propDef) {
        //如果是人员选择 则获取id即可
        unref(modelObj)[unref(model).key] = userJson["id"];
        backFun && backFun(userJson["id"]);
        return
      }
      //租户id
      if (CommonEnum.TENANT_NAME_ID === propDef) {
        //如果是人员选择 则获取id即可
        unref(modelObj)[unref(model).key] = userJson["tenantId"];
        backFun && backFun(userJson["tenantId"]);
        return
      }
      //租户名称
      if (CommonEnum.TENANT_NAME === propDef) {
        //如果是人员选择 则获取id即可
        unref(modelObj)[unref(model).key] = userJson["tenantName"];
        backFun && backFun(userJson["tenantName"]);
        return
      }
    })
    return
  }
  //当前机构
  if (CommonEnum.CURRENT_ORG === propDef) {
    CurrentUtils._loadUser(false, (userJson) => {
      backFun && backFun(userJson["deptName"] || '无部门');
      return unref(modelObj)[unref(model).key] = userJson["deptName"] || '无部门';
    })
    return
  }

  //当前机构
  if (CommonEnum.CURRENT_ORG_ID === propDef) {
    CurrentUtils._loadUser(false, (userJson) => {
      backFun && backFun(userJson["deptId"] || '无部门');
      return unref(modelObj)[unref(model).key] = userJson["deptId"] || '无部门';
    })
    return
  }

  const getElKey = function () {
    return unref(model).key;
  }
  if (propDef != null && unref(modelObj)) {
    try {
      if (componentKey === 'xmSwitch') {
        if (unref(modelObj)[getElKey()] == null || unref(modelObj)[unref(model).key] === "") {
          unref(modelObj)[getElKey()] = GoingNewUtils.parseBoolean((propDef + "").trim())
        }
      } else {
        unref(modelObj)[getElKey()] = (propDef + "").trim();
        if (propDef === '' && valueType) {
          setTimeout(() => {
            unref(modelObj)[getElKey()] = valueType;
          })
        }
      }
    } catch (e) {

    }
  }
}


export function cashToChinese(cash) {
  var digits = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
  var largeUnits = ['元', '万', '亿'];
  var units = ['', '拾', '佰', '仟'];
  var fractions = ['角', '分'];
  let cStr = '';
  cash = (cash + '').toString();
  if (cash === '' || cash === undefined || cash === null) {
    return cStr;
  }
  let preCash = cash.split('.')[0] || '';
  let lastCash = cash.split('.')[1] || '00';
  if (preCash.length > 12 || lastCash.length > 2) {
    return cStr;
  }
  //遍历小数位
  for (let i = 0; i < fractions.length; i++) {
    if (lastCash.charAt(i)) {
      cStr += (digits[lastCash.charAt(i)] + fractions[i]).replace(/零./, '');
    }
  }
  cStr = cStr || '整';
  //遍历整数位，用str来记录每4位的值
  for (let i = preCash.length - 1, n = 0, str = ''; i >= 0; i--) {
    let largeUnit = '';
    str = (digits[preCash[i]] + units[n % 4]) + str;
    //用n计数每隔4位，或者遍历到头的时候加单位（'元','万','亿'）
    if ((n + 1) % 4 === 0 || i === 0) {
      largeUnit = largeUnits[Math.floor(n / 4)];
      //考虑替换末位全是0时替换位空 或者中间连续0时替换为零
      str = str.replace(/(零.)*零$/g, '').replace(/(零.)+/g, '零');
      str += largeUnit;
      cStr = str + cStr;
      str = '';
    }
    n++;
  }
  //考虑处理（'元','万','亿'）单位前为10的情况，和整数位为0的情况
  return cStr.replace(/壹拾(.){0,1}([元|万|亿])/g, '拾$1$2').replace(/^元/, '');
}

